import { render } from "./SAML.vue?vue&type=template&id=ab66edaa&scoped=true&ts=true"
import script from "./SAML.vue?vue&type=script&lang=ts"
export * from "./SAML.vue?vue&type=script&lang=ts"

import "./SAML.vue?vue&type=style&index=0&id=ab66edaa&lang=scss&scoped=true"

import exportComponent from "/Users/rathasitjearnpasawarn/var/apps/happily-accounts/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab66edaa"]])

export default __exports__